import React from 'react'
import styles from './MicrositePopupPreview.module.css'
import { X } from 'lucide-react'

/**
 * MicrositePopupPreview
 * Live preview card showing how a popup will render on the live
 * site — used inside MicrositePopupEditor as the user types.
 *
 * Usage:
 *   <MicrositePopupPreview content={form.content} />
 *   // content: { heading, body, image, cta: { label, url } }
 */
const MicrositePopupPreview = ({ content = {} }) => {
    const { heading, body, image, cta } = content

    return (
        <div className={styles.stage}>
            <div className={styles.label}>Live preview</div>
            <div className={styles.backdrop}>
                <div className={styles.card}>
                    <button type="button" className={styles.closeBtn}>
                        <X size={13} />
                    </button>

                    {image && (
                        <img
                            src={image}
                            alt=""
                            className={styles.image}
                            onError={(e) => { e.currentTarget.style.display = 'none' }}
                        />
                    )}

                    <div className={styles.body}>
                        <h3 className={styles.heading}>{heading || 'Your popup heading'}</h3>
                        <p className={styles.text}>{body || 'Your popup message will appear here.'}</p>
                        <button type="button" className={styles.ctaBtn}>
                            {cta?.label || 'Call to action'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MicrositePopupPreview